<template>
  <div>
    <div v-if="customPlansPage" class="section-min-width">
      <SlicesBlock :slices="slices" />
    </div>
    <b-container v-else fluid class="main-container">
      <PlansHeader :lifetime="true" :show-switch="false" />
      <div
        class="lifetime-plans justify-content-center align-items-center"
        :class="{ 'd-flex': !lifetimePlans.length }"
      >
        <Loading v-if="!lifetimePlans.length" />
        <PurchaseFlow
          v-else
          :show-plans="true"
          :plans-new-page="true"
          :plans-page="true"
          :lifetime="true"
        />
      </div>
      <b-container>
        <Video
          id="plans-video-container"
          :options="playerOptions"
          :classes="'video-player-box overflow-hidden rounded w-100 mt-5 mb-5'"
        />
      </b-container>
      <LicensesBlock :lifetime="true" />
      <Faq :lifetime="true" />
      <GetGraphics :lifetime="true" />
      <IconBlock :lifetime="true" />
      <Testimonials :title="$t(`plans.${getExperience}.tags.testimonialsTitle`)" />
      <SubscribeBanner :lifetime="true" />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Faq from '@/components/Common/Faq';
import GetGraphics from 'Plans/GetGraphics';
import IconBlock from 'Plans/IconBlock';
import LicensesBlock from 'Plans/LicensesBlock';
import Loading from 'UI/Loading';
import PlansHeader from 'Plans/Header';
import PurchaseFlow from '@/components/PurchaseFlow';
import SubscribeBanner from 'Plans/SubscribeBanner';
import Testimonials from '@/components/Common/Testimonials';
import Video from '@/components/Common/Video';
import SlicesBlock from '@/components/Prismic/Landings/SlicesBlock.vue';

export default {
  name: 'LifetimePlans',
  components: {
    Faq,
    GetGraphics,
    IconBlock,
    LicensesBlock,
    Loading,
    PlansHeader,
    PurchaseFlow,
    SubscribeBanner,
    Testimonials,
    Video,
    SlicesBlock
  },
  async asyncData({ $prismic, store }) {
    try {
      let languages = $prismic.api.data.languages;
      let language = languages.find((item) => item.id.indexOf(store.$i18n.locale) != -1);

      await store.dispatch('config/SEASONAL_STATUS');
      const isSeasonalActive = store.getters['config/isSeasonalActive'];
      const merchPlansUid = isSeasonalActive ? 'lifetime-plans-seasonal' : 'lifetime-plans';

      const result = await $prismic.api.getByUID('post', merchPlansUid, { lang: language.id });

      if (!result) {
        return {
          customPlansPage: false
        };
      }
      const pageConfiguration = result.data.body.find(
        (slice) => slice.slice_type === 'page_configuration'
      );
      if (pageConfiguration) {
        await store.dispatch('config/SET_PRISMIC_PAGE_CONFIGURATION', pageConfiguration.primary);
      }
      return {
        slices: result.data.body,
        customPlansPage: true
      };
    } catch (e) {
      return {
        customPlansPage: false
      };
    }
  },
  data() {
    return {
      playerOptions: {
        language: 'en',
        playbackRates: [1.0],
        sources: [
          {
            type: 'video/mp4',
            src: 'https://images.vexels.com/files/web/assets/meet-vexels.mp4'
          }
        ],
        poster: 'https://cdn.vexels.com/img/preview-video-vexels.jpg'
      }
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    ...mapGetters('plans', ['lifetimePlans'])
  },
  async mounted() {
    if (!this.customPlansPage) {
      const merchLifetimePlan = await this.$store.dispatch('plans/GET_PLAN', '25');
      const extendedLifetimePlan = await this.$store.dispatch('plans/GET_PLAN', '26');

      this.$store.commit('plans/SET_LIFETIME_PLANS', [merchLifetimePlan, extendedLifetimePlan]);
    }
  }
};
</script>

<style scoped>
.main-container {
  padding: 0;
}
.lifetime-plans {
  min-height: 375px;
}
</style>
